// src/misc/america250/america250Config.js

export const AMERICA250_SHEET = {
  sheetId: "13XOTSB4fvS7dCNstwCdADoZh6Pwm2x6k7QTiS5GU6dA",
  gid: "0",
};

// “Security by obscurity” link slug (good enough if you only care about not advertising it)
// You can rotate this at any time.
export const AMERICA250_ROUTE = "v/america250/7d3f1d2a-6b7a-4a07-bc5b-1fdb8c0f2d91";
